<template>
    <v-row class="pa-0" no-gutters>
        <v-col cols="6">
            <v-dialog
                    ref="startDateDialog"
                    v-model="isShowStartDateMenu"
                    :return-value.sync="queryData.startDateTime"
                    persistent
                    width="70%"
                    max-width="620"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                            v-model="queryData.startDateTime"
                            :label="label+'开始时间'"
                            prepend-icon="event"
                            readonly
                            :rules="startDateRules"
                            v-on="on"
                            clearable
                            :hide-details="hideDetails"
                    ></v-text-field>
                </template>
                <div v-if="isShowStartDateMenu"
                     class="pa-2"
                     style="background-color:#fff;">
                    <div style="display:flex;align-items: stretch;justify-content: space-between">
                        <v-date-picker
                                v-model="queryData.startDate"
                                :allowed-dates="allowedStartDates"
                        >
                        </v-date-picker>
                        <v-time-picker
                                :allowed-hours="allowedStartHours"
                                :allowed-minutes="allowedStartMinutes"
                                :allowed-seconds="allowedStartSeconds"
                                format="24hr"
                                use-seconds
                                v-model="queryData.startTime"
                        >
                        </v-time-picker>
                    </div>

                    <v-spacer></v-spacer>

                    <div class="pt-2 pb-2 text-center">
                        <v-btn text color="primary" @click="isShowStartDateMenu = false">取消</v-btn>
                        <v-btn color="primary"
                               @click="startDateConfirm">确定
                        </v-btn>
                    </div>

                </div>
            </v-dialog>

        </v-col>

        <v-col cols="6">
            <v-dialog
                    ref="endDateDialog"
                    v-model="isShowEndDateMenu"
                    :return-value.sync="queryData.endDateTime"
                    persistent
                    width="70%"
                    max-width="620"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                            class="pl-4"
                            v-model="queryData.endDateTime"
                            :rules="endDateRules"
                            :label="label+'结束时间'"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            :hide-details="hideDetails"
                    ></v-text-field>
                </template>
                <div v-if="isShowEndDateMenu"
                     class="pa-2"
                     style="background-color:#fff;">
                    <div style="display:flex;align-items: stretch;justify-content: space-between">
                        <v-date-picker
                                :allowed-dates="allowedEndDates"
                                v-model="queryData.endDate"
                        >
                        </v-date-picker>
                        <v-time-picker
                                :allowed-hours="allowedEndHours"
                                :allowed-minutes="allowedEndMinutes"
                                :allowed-seconds="allowedEndSeconds"
                                format="24hr"
                                use-seconds
                                v-model="queryData.endTime"
                        >
                        </v-time-picker>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="pt-2 pb-2 text-center">
                        <v-btn text color="primary" @click="isShowEndDateMenu = false">取消</v-btn>
                        <v-btn color="primary"
                               @click="endDateConfirm">确定
                        </v-btn>
                    </div>
                </div>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
  export default {
    name: "ZSelectDate",
    props: {
      value: {
        type: [Array],
        required: true
      },
      label:{
        type:String,
        default:''
      },
      startDateRules:{
        type: Array,
        required: false,
        default: () => [ v => !!v || '开始时间必输']
      },
	  startDates:{
		 type:String,
		 default:''
	  },
	  endDates:{
		  type:String,
		  default:''
	  },
      endDateRules:{
        type: Array,
        required: false,
        default: () => [ v => !!v || '结束时间必输']
      },
      // 隐藏提示和验证错误。当设置为 auto 时，只有在有信息（提示、错误信息、计数器值等）要显示时，才会显示信息。
      hideDetails:{
        type: [Boolean,String],
        required: false,
        default: false
      },
    },
    data: () => ({
      isShowStartDateMenu: false,
      isShowEndDateMenu: false,
      isShowTimeMenu: false,
      isShowEndTimeMenu: false,
      queryData: {
        startDateTime: 'asddas',
        endDateTime: 'dasadsasd',
        startDate: '',
        endDate: '',
        startTime: '00:00:00',
        endTime: '00:00:00'
      },
    }),
    watch: {
		
      // 清除开始日期
      'queryData.startDateTime': function (newValue, oldValue) {
        if (!newValue) {
          this.queryData.startDate = '';
          this.queryData.startTime = '00:00:00';
          this.queryData.startDateTime="";
        }
        if(!this.queryData.startDateTime&&!this.queryData.endDateTime){
          this.$emit('input', []);
          return;
        }
        this.$emit('input', [this.queryData.startDateTime, this.queryData.endDateTime])
      },
      // 清除结束日期
      'queryData.endDateTime': function (newValue, oldValue) {
        if (!newValue) {
          this.queryData.endDate = '';
          this.queryData.endTime = '00:00:00';
          this.queryData.endDateTime="";
        }
        if(!this.queryData.startDateTime&&!this.queryData.endDateTime){
          this.$emit('input', []);
          return;
        }
        this.$emit('input', [this.queryData.startDateTime, this.queryData.endDateTime])
      },
    },
    methods: {
      allowedStartDates(val) {
        if (!this.queryData.endDate) {
          return Date.parse(val) <= Date.now()
        } else {
          return Date.parse(this.queryData.endDate) >= Date.parse(val) && Date.parse(val) <= Date.now();
        }
      },
      allowedEndDates(val) {
        if (!this.queryData.startDate) {
          return Date.parse(val) <= Date.now()
        } else {
          return Date.parse(this.queryData.startDate) <= Date.parse(val) && Date.parse(val) <= Date.now();
        }
      },
      allowedEndHours(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.startTime != '00:00:00') {
          return val >= this.queryData.startTime.substr(0, 2) * 1
        } else {
          return true;
        }
      },
      allowedEndMinutes(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.startTime != '00:00:00') {
          if (this.queryData.startTime.substr(0, 2) * 1 < this.queryData.endTime.substr(0, 2) * 1) {
            return true;
          } else {
            return val >= this.queryData.startTime.substr(3, 2) * 1
          }
        } else {
          return true;
        }
      },
      allowedEndSeconds(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.startTime != '00:00:00') {
          if (this.queryData.startTime.substr(0, 2) * 1 < this.queryData.endTime.substr(0, 2) * 1) {
            return true;
          } else {
            if (this.queryData.startTime.substr(3, 2) * 1 < this.queryData.endTime.substr(3, 2) * 1) {
              return true;
            } else {
              return val >= this.queryData.startTime.substr(6, 2) * 1;
            }
          }
        } else {
          return true;
        }
      },
      allowedStartHours(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.endTime != '00:00:00') {
          return val <= this.queryData.endTime.substr(0, 2) * 1
        } else {
          return true;
        }
      },
      allowedStartMinutes(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.endTime != '00:00:00') {
          if (this.queryData.startTime.substr(0, 2) * 1 < this.queryData.endTime.substr(0, 2) * 1) {
            return true;
          } else {
            return val <= this.queryData.endTime.substr(3, 2) * 1
          }
        } else {
          return true;
        }
      },
      allowedStartSeconds(val) {
        if (Date.parse(this.queryData.startDate) != Date.parse(this.queryData.endDate)) {
          return true;
        }
        if (this.queryData.endTime != '00:00:00') {
          if (this.queryData.startTime.substr(0, 2) * 1 < this.queryData.endTime.substr(0, 2) * 1) {
            return true;
          } else {
            if (this.queryData.startTime.substr(3, 2) * 1 < this.queryData.endTime.substr(3, 2) * 1) {
              return true;
            } else {
              return val <= this.queryData.endTime.substr(6, 2) * 1;
            }
          }
        } else {
          return true;
        }
      },
      startDateConfirm() {
        if (!this.queryData.startDate) {
          this.$refs.startDateDialog.save('')
        } else {
          this.$refs.startDateDialog.save(this.queryData.startDate + ' ' + this.queryData.startTime);
        }
      },
      endDateConfirm() {
        if (!this.queryData.endDate) {
          this.$refs.endDateDialog.save('');
        } else {
          this.$refs.endDateDialog.save(this.queryData.endDate + ' ' + this.queryData.endTime);
        }
      }
    },
    mounted() {
		 this.queryData.startDateTime= this.startDates
		 this.queryData.endDateTime= this.endDates
		 console.log(this.startDates,"nihaowa",this.endDates);
    }
  }
</script>

<style scoped>

</style>